import { observer } from 'mobx-react';
import { Flex } from 'antd';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';
import TaskCard from './TaskCard';

const InWorkTasksPage = () => {
  return (
    <Flex vertical gap={12}>
      {StagesStore.dataMyTasks.map((task) => (
        <TaskCard key={task._id} {...task} />
      ))}
    </Flex>
  );
};

export default observer(InWorkTasksPage);
